import styles from "../YourAdvantage/YourAdvantage.module.css";
import TitleBar from "../../TitleBar/TitleBar";

const YourAdvantage = ({ fetchYourAdvantagedata }) => {
  const renderChars = (value = "", className) => (
    <h2 className={className}>
      {Array.from(String(value).toUpperCase()).map((ch, i) => (
        <span key={`${ch}-${i}`}>{ch}</span>
      ))}
    </h2>
  );
  return (
    <>
      <div className={styles.containerBox}>
        <div className={styles.TitleBarDiv}>
          <TitleBar blocks={fetchYourAdvantagedata?.subTitle} />
        </div>
        <div className={styles.container}>
          {/* First Card */}
          <div className={`${styles.card} ${styles.cardPrimary}`}>
            <div className={styles.contentdiv}>
              <div className={styles.icon + " " + styles.callIcon}>
                <img
                  src={
                    fetchYourAdvantagedata?.firstCard?.icon?.src ||
                    "/Svg/call-svg.svg"
                  }
                  alt={fetchYourAdvantagedata?.firstCard?.icon?.alt || "call"}
                  loading="lazy"
                />
              </div>
              <div className={styles.forgrid}>
                <div>
                  {renderChars(
                    fetchYourAdvantagedata?.firstCard?.displayValue || "50K+",
                    styles.bigText
                  )}
                </div>

                <div className={styles.BottomContaint}>
                  <div className={styles.btn}
                     onClick={() =>
                window.open(
                  "https://app.rxpt.ai/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
                  >
                    <img src="/Svg/join-btn.svg" alt="join-btn" />
                  </div>
                  <div className={styles.SubTextDisc}>
                    <p className={styles.subText}>
                      {fetchYourAdvantagedata?.firstCard?.label}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Card */}
          <div className={styles.card}>
            <div className={styles.contentdiv}>
              <div className={styles.icon + " " + styles.starIcon}>
                <img
                  src={
                    fetchYourAdvantagedata?.secondCard?.icon?.src ||
                    "/Svg/star-svg.svg"
                  }
                  alt={fetchYourAdvantagedata?.secondCard?.icon?.alt || "stars"}
                  loading="lazy"
                />
              </div>

              <div className={styles.forgrid}>
                <div>
                  {renderChars(
                    fetchYourAdvantagedata?.secondCard?.displayValue || "95%",
                    styles.percent
                  )}
                </div>
                <div>
                  <p className={styles.subText2}>
                    {fetchYourAdvantagedata?.secondCard?.label}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Third Card */}
          <div className={styles.card}>
            <div className={styles.contentdiv}>
              <div className={styles.icon + " " + styles.costIcon}>
                <img
                  src={
                    fetchYourAdvantagedata?.thirdCard?.icon?.src ||
                    "/Svg/cost-svg.svg"
                  }
                  alt={fetchYourAdvantagedata?.thirdCard?.icon?.alt || "cost"}
                  loading="lazy"
                />
              </div>
              <div className={styles.forgrid}>
                <div>
                  {renderChars(
                    fetchYourAdvantagedata?.thirdCard?.displayValue || "80%",
                    styles.percent
                  )}
                </div>
                <div>
                  <p className={styles.subText2}>
                    {fetchYourAdvantagedata?.thirdCard?.label}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.btnmob}
            onClick={() =>
              window.open(
                "https://app.rxpt.ai/",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {/* <AnimatedBtn text2="Join" logo="/Svg/rexpt-logo2.svg" shapeType="alt"/> */}
            <img src="/Svg/join-btn2.svg" alt="join-btn2" />
          </div>
        </div>
      </div>
    </>
  );
};

export default YourAdvantage;
